import { observer } from 'mobx-react-lite';
import SendViewContent from './SendViewContent';
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  isWritting: boolean;
  sendAddress: string;
  sendAsset: string;
  trxAsset: ViewModel.IAsset | undefined;
  tokenAsset: ViewModel.IAsset | undefined;
  selectedAsset: ViewModel.IAsset | undefined;
  curculateKrw: string;
  isSendCheckBtnDisabled: boolean;
  isInvalidAddressModalOpen: boolean;
  isBalanceNotEnoughModalOpen: boolean;
  isClipboardErrorModalOpen: boolean;
  defaultMemo: string;
  onChangeMemo: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeSendAddress: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeSelectedAsset: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeSelectedAssetValue: (assetType: ViewModel.AssetType) => void;
  onClickDeleteBtn: () => void;
  onClickResetAmountBtn: () => void;
  onPaste: (text: string) => void;
  onClickSendCheckBtn: () => void;
  onClickInvalidAddressModalClose: () => void;
  onClickBalanceNotEnoughModalConfirm: () => void;
  onClickSendCancelBtn: () => void;
  onClickCameraBtn: () => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onSetMemo?: (memo: string) => void;
  memo: string;
  onClipboardError: () => void;
  onClickClipboardErrorModalClose: () => void;
}

const SendView = observer(
  ({
    isWritting,
    sendAddress,
    sendAsset,
    trxAsset,
    tokenAsset,
    selectedAsset,
    curculateKrw,
    isSendCheckBtnDisabled,
    isInvalidAddressModalOpen,
    isBalanceNotEnoughModalOpen,
    isClipboardErrorModalOpen,
    defaultMemo,
    onChangeMemo,
    onClickSendCheckBtn,
    onClickInvalidAddressModalClose,
    onClickBalanceNotEnoughModalConfirm,
    onClickSendCancelBtn,
    onPaste,
    onChangeSendAddress,
    onChangeSelectedAsset,
    onChangeSelectedAssetValue,
    onClickDeleteBtn,
    onClickResetAmountBtn,
    onClickCameraBtn,
    onKeyPress,
    onSetMemo,
    memo,
    onClipboardError,
    onClickClipboardErrorModalClose,
  }: IProps) => {
    return (
      <>
        <div className="container"></div>
        <SendViewContent
          defaultMemo={defaultMemo}
          isWritting={isWritting}
          sendAddress={sendAddress}
          sendAsset={sendAsset}
          trxAsset={trxAsset}
          tokenAsset={tokenAsset}
          selectedAsset={selectedAsset}
          curculateKrw={curculateKrw}
          isSendCheckBtnDisabled={isSendCheckBtnDisabled}
          isInvalidAddressModalOpen={isInvalidAddressModalOpen}
          isBalanceNotEnoughModalOpen={isBalanceNotEnoughModalOpen}
          isClipboardErrorModalOpen={isClipboardErrorModalOpen}
          onChangeMemo={onChangeMemo}
          onClickSendCheckBtn={onClickSendCheckBtn}
          onClickInvalidAddressModalClose={onClickInvalidAddressModalClose}
          onClickBalanceNotEnoughModalConfirm={onClickBalanceNotEnoughModalConfirm}
          onClickSendCancelBtn={onClickSendCancelBtn}
          onPaste={onPaste}
          onChangeSendAddress={onChangeSendAddress}
          onChangeSelectedAsset={onChangeSelectedAsset}
          onChangeSelectedAssetValue={onChangeSelectedAssetValue}
          onClickDeleteBtn={onClickDeleteBtn}
          onClickResetAmountBtn={onClickResetAmountBtn}
          onClickCameraBtn={onClickCameraBtn}
          onKeyPress={onKeyPress}
          onSetMemo={onSetMemo}
          memo={memo}
          onClipboardError={onClipboardError}
          onClickClipboardErrorModalClose={onClickClipboardErrorModalClose}
        />
      </>
    );
  },
);

export default SendView;
